module.exports = __webpack_public_path__ + "static/media/cartFull.ddf286d8.svg";